// extracted by mini-css-extract-plugin
export default {"recos":"w6-z","productCardOverride":"x6-z","rowHasBadge":"y6-z"};